/**
 * Offices' displayed assignment percentage: assigned people / installed seats,
 * rounded to a whole percent, without a 100% cap. Missing inputs or a
 * non-positive seat denominator have no percentage (not 0%).
 */
export function assignmentPercentage(installedSeats, assignedHeadcount) {
  const seats = installedSeats != null ? Number(installedSeats) : null;
  const people = assignedHeadcount != null ? Number(assignedHeadcount) : null;
  return people != null && seats != null && seats > 0
    ? Math.round((people / seats) * 100)
    : null;
}
